import { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { UserService } from '../services/usuarios';
import { IProfile } from '../interfaces/usuarios';

// Definição da interface do contexto
interface UserContextType {
  token: string | null;
  user: IProfile | null | undefined;
  setUser: (user: IProfile | null | undefined) => void;
  logout: () => void;
}

// Criação do contexto com o tipo `UserContextType | undefined`
const UserContext = createContext<UserContextType | undefined>(undefined);

const instance = new UserService();

// Criação do provider
export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

  const [user, setUser] = useState<IProfile | null | undefined>(null);
  
  const token = sessionStorage.getItem('token');

  // Função para buscar o perfil do usuário
  const getProfile = () => {
    instance.getProfile()
      .then(data => {
        setUser(data);
        
      })
      .catch(error => console.error('Erro ao obter perfil', error));
  };
  const logout = () => {
    setUser(null);
    sessionStorage.clear();
  };

  useEffect(() => {
    if (token) {
      getProfile();
    }
  }, [token]);

  return (
    <UserContext.Provider value={{ token, user, setUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

// Hook personalizado para usar o UserContext
export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

export default UserContext;
